import { render } from "./CurrencyBalances.vue?vue&type=template&id=d64c5556&scoped=true"
import script from "./CurrencyBalances.vue?vue&type=script&lang=js"
export * from "./CurrencyBalances.vue?vue&type=script&lang=js"

import "./CurrencyBalances.vue?vue&type=style&index=0&id=d64c5556&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d64c5556"]])

export default __exports__